export default __webpack_public_path__ + "static/media/Twitter.96ce2bee.svg";